<template>
  <div class="all-users-page test-class">
    <h1 class="page-header color-1-100">Logs</h1>
    <div class="admin-gm-breadcrumbs">
      <router-link class="email-logs" :to="{ name: 'email-logs' }">Email logs</router-link>
      <router-link class="dashboard" :to="{ name: 'consent-logs' }">Consent logs</router-link>
      <router-link class="ttd-logs active" :to="{name: 'logs'}">Logs</router-link>
    </div>
    <div class="content-section">
      <div class="data-list-statusbar"
           v-if="!selectedFilters.length"
           style="margin: 0 15px 20px;">
        <div class="data-list-statusbar__contains data-list-statusbar__block">{{ logsCount }} logs</div>
      </div>
      <div class="data-list-selected-filters" v-if="getDeviceType('desktop') && selectedFilters.length">
        <div class="data-list-selected-filters-applied">
          <span>Filters applied:<br/>{{ this.logs.length }} results</span>
        </div>
        <div class="data-list-selected-filters-body">
          <button v-for="filter in selectedFilters"
                  type="button"
                  @click="removeSelectedFilters(filter)"
                  @mouseover="addHoverElement([filter])"
                  @mouseleave="removeHoverElements"
                  :class="{'hover-filter-element': isExist(filter)}">
            <span>{{ filter.label }}</span>
          </button>
          <span class="data-list-selected-filters-remove-all"
                @click="removeAllFilters"
                @mouseover="statusbar.filter.isHover = true"
                @mouseleave="statusbar.filter.isHover = false">Clear all filters</span>
        </div>
      </div>
      <div class="data-list-body">
        <table class="table table-data">
          <thead v-bind:filters="getTabletFiltersAppliedText()">
          <tr class="inside-table-filters" v-if="(getDeviceType('tablet') || getDeviceType('mobile')) &&  selectedFilters.length">
            <th colspan="9">
              <div class="data-list-selected-filters-body">
                <button v-for="filter in selectedFilters"
                        type="button"
                        @click="removeSelectedFilters(filter)"
                        @mouseover="addHoverElement([filter])"
                        @mouseleave="removeHoverElements"
                        :class="{'hover-filter-element': isExist(filter)}">
                  <span>{{ filter.label }}</span>
                </button>
                <span class="data-list-selected-filters-remove-all"
                      @click="removeAllFilters"
                      @mouseover="statusbar.filter.isHover = true"
                      @mouseleave="statusbar.filter.isHover = false">Clear all filters</span>
              </div>
            </th>
          </tr>
          <tr>
            <th class="data-list-search-col text-left column-search-head table-head-ceil"
                style="width: 194px;"
                :class="{
                  'active-ceil-head': filerTableHead.selectedCeil === 1,
                  'hover-head-ceil': isExistInOptions(getUsersForSelect),
                  'locked-ceil-head': userFilterLocked
                }"
                @click.stop="showHideSubMenu(1)"
                @mouseover="addHoverElement(getUsersForSelect)"
                @mouseleave="removeHoverElements">
              <div class="caption-head caption-head-icon" :class="{'active': filerTableHead.selectedCeil === 1}">
                <div class="caption-head-text">
                  <span class="caption-head-inner-text">User</span>
                </div>
              </div>
              <div class="wrap-dropdown-table-head"
                   id="sub-menu-1"
                   v-show="filerTableHead.selectedCeil === 1"
                   tabindex="-1"
                   @click.stop="">
                <app-select placeholder="Search"
                            :options="getUsersForSelect"
                            :class="table-head-search"
                            v-model="logsUser" />
              </div>
            </th>
            <th class="data-list-search-col text-left column-search-head table-head-ceil"
                style="width: 194px;"
                :class="{
                  'active-ceil-head': filerTableHead.selectedCeil === 2,
                  'hover-head-ceil': isExistInOptions(getEmailsForSelect),
                  'locked-ceil-head': emailFilterLocked
                }"
                @click.stop="showHideSubMenu(2)"
                @mouseover="addHoverElement(getEmailsForSelect)"
                @mouseleave="removeHoverElements">
              <div class="caption-head caption-head-icon" :class="{'active': filerTableHead.selectedCeil === 2}">
                <div class="caption-head-text">
                  <span class="caption-head-inner-text">Email</span>
                </div>
              </div>
              <div class="wrap-dropdown-table-head"
                   id="sub-menu-2"
                   v-show="filerTableHead.selectedCeil === 2"
                   tabindex="-1"
                   @click.stop="">
                <app-select placeholder="Search"
                            :options="getEmailsForSelect"
                            :class="table-head-search"
                            v-model="logsEmail" />
              </div>
            </th>
            <th class="column-role-head table-head-hover table-head-ceil"
                :class="{
                  'active-ceil-head': filerTableHead.selectedCeil === 3,
                  'hover-head-ceil': isExistInOptions(getCompaniesForSelect),
                  'locked-ceil-head': companyFilterLocked
                }"
                @click.stop="showHideSubMenu(3)"
                @mouseover="addHoverElement(getCompaniesForSelect)"
                @mouseleave="removeHoverElements">
              <div class="caption-head caption-head-icon" :class="{'active': filerTableHead.selectedCeil === 3}">
                <div class="caption-head-text">
                  <span class="caption-head-inner-text">Company</span>
                </div>
              </div>
              <div class="wrap-dropdown-table-head"
                   id="sub-menu-3"
                   v-show="filerTableHead.selectedCeil === 3"
                   tabindex="-1"
                   @click.stop="">
                <app-select placeholder="Search"
                            :options="getCompaniesForSelect"
                            :class="table-head-search"
                            v-model="logsCompany" />
              </div>
            </th>
            <th class="column-status-head table-head-ceil"
                :class="{'hover-head-ceil': isExistInOptions(getActionsForSelect)}"
                @click.stop="showHideSubMenu(4)"
                @mouseover="addHoverElement(getActionsForSelect)"
                @mouseleave="removeHoverElements">
              <div class="caption-head caption-head-icon" :class="{'active': filerTableHead.selectedCeil === 4}">
                <div class="caption-head-text">
                  <span class="caption-head-inner-text">Action</span>
                </div>
              </div>
              <div class="wrap-dropdown-table-head"
                   id="sub-menu-4"
                   v-show="filerTableHead.selectedCeil === 4"
                   tabindex="-1"
                   @click.stop="">
                <app-select placeholder="Search"
                            :options="getActionsForSelect"
                            v-model="logsAction" />
              </div>
            </th>
            <th class="column-created-head table-head-ceil"
                @click.stop="changeOrderBy(true)">
              <div class="caption-head caption-head-order">
                <div class="caption-head-text">
                  <span class="caption-head-inner-text">Date and time</span>
                </div>
                <div class="caption-head-order-change">
                  <div class="caption-head-order-up"
                       :class="{'active': this.logOrderBy !== null && this.logOrderBy.order}"></div>
                  <div class="caption-head-order-down"
                       :class="{'active': this.logOrderBy !== null && !this.logOrderBy.order}"></div>
                </div>
              </div>
            </th>
            <th class="column-active-head table-head-ceil">
              <div class="caption-head">
                <div class="caption-head-text">
                  <span class="caption-head-inner-text">Details</span>
                </div>
              </div>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(log, i) in logs">
            <td class="name-cell cellpadding" data-title="User:">{{ getUser(log) }}</td>
            <td class="email-cell cellpadding" data-title="Email:">{{ getEmail(log) }}</td>
            <td class="email-cell cellpadding" data-title="Company:">{{ log.companyName ? log.companyName : 'n/a' }}</td>
            <td class="role-cell cellpadding" data-title="Action:">{{ getActionName(log) }}</td>
            <td class="created-cell cellpadding text-center" data-title="Date and time:">{{ convertDate(log.createdAt) }}</td>
            <td class="last-login-cell cellpadding text-center" data-title="Details:" style="text-align: left;">{{ log.action ? log.action : 'n/a' }}</td>
          </tr>
          </tbody>
        </table>
        <div class="load-more-container" v-if="this.logs.length < this.logsCount">
          <div class="load-more-btn" @click="loadMore()">
            <div id="wave"><span class="dot"></span><span class="dot"></span><span class="dot"></span></div>Load more
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import AppSelect from '@/components/admin/common/Select'

export default {
  name: 'company-list',
  data () {
    return {
      ppt: 15,
      offset: 0,
      limit: 15,
      order: 'desc',
      logsCount: 0,
      search: '',
      table: '',
      head: '',
      logs: [],
      hoverSearchElements: [],
      logUsers: null,
      logCompanies: null,
      logActions: null,
      usersFilter: [],
      emailsFilter: [],
      companiesFilter: [],
      actionsFilter: [],
      logsUser: null,
      logsEmail: null,
      logsCompany: null,
      logsAction: null,
      logOrderBy: {
        order: false
      },
      companyFilterLocked: false,
      userFilterLocked: false,
      emailFilterLocked: false,
      serverValidation: {
        errors: []
      },
      hoverElements: [],
      filerTableHead: {
        selectedCeil: null
      },
      statusbar: {
        filter: {
          isHover: false
        }
      },
      windowWidth: window.innerWidth
    }
  },
  methods: {
    fetchAllContentByScroll (reInit) {
      let user = ''
      if (this.logsUser) {
        user = this.logsUser.id
      } else if (this.logsEmail) {
        user = this.logsEmail.id
      }
      let body = {
        offset: this.offset,
        limit: this.limit,
        order: this.order,
        companyId: this.logsCompany ? this.logsCompany.id : '',
        userId: user,
        action: this.logsAction ? this.logsAction.id : ''
      }
      this.$http.post(api.URLS.logs, body, api.headersAuthSettings)
        .then((res) => {
          this.logsCount = res.body.count
          if (reInit) {
            this.logs = []
          }
          this.logs = this.logs.concat(res.body.data)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getAllFilters () {
      let self = this
      Promise.all([
        this.$http.post(api.URLS.filterLogs, {}, api.headersAuthSettings),
        this.$http.post(api.URLS.filterLogCompanies, {}, api.headersAuthSettings),
        this.$http.post(api.URLS.filterLogUsers, {}, api.headersAuthSettings)
      ]).then(function (data) {
        self.logActions = data[0].body
        self.logCompanies = data[1].body
        self.logUsers = data[2].body
      })
    },
    updateUsersFilter () {
      let body = {
        companyId: this.logsCompany ? this.logsCompany.id : ''
      }
      this.$http.post(api.URLS.filterLogUsers, body, api.headersAuthSettings)
          .then((res) => {
            this.logUsers = res.body
          })
          .catch((err) => {
            console.log(err)
          })
    },
    addHoverElement (elements) {
      this.hoverElements = elements
    },
    removeHoverElements () {
      this.hoverElements = []
    },
    isExist (element) {
      if (element.type !== undefined && this.hoverSearchElements === element.type) {
        return true
      }
      let el = this.hoverElements.find(item => {
        if ((element.value === item.value || item.value === null) && element.label === item.label) {
          return true
        }
      })
      return !!el
    },
    isExistInOptions (options) {
      let hoverElement = this.hoverElements.length ? this.hoverElements[0] : {}
      let el = options.find(item => {
        if ((hoverElement.value === item.value || hoverElement.value === null) && hoverElement.label === item.label) {
          return true
        }
      })
      return !!el
    },
    isExistSearchInOptions (type) {
      let hoverElement = this.hoverSearchElements ? this.hoverSearchElements : ''
      if (hoverElement === type) {
        return true
      }
    },
    removeSelectedFilters (filter) {
      if (this.logsUser && this.logsUser.label === filter.label && this.logsUser.value === filter.value) {
        this.logsUser = null
      }
      if (this.logsEmail && this.logsEmail.label === filter.label && this.logsEmail.value === filter.value) {
        this.logsEmail = null
      }
      if (this.logsCompany && this.logsCompany.label === filter.label && this.logsCompany.value === filter.value) {
        this.logsCompany = null
      }
      if (this.logsAction && this.logsAction.label === filter.label && this.logsAction.value === filter.value) {
        this.logsAction = null
      }
    },
    removeAllFilters () {
      this.logsUser = null
      this.logsEmail = null
      this.logsCompany = null
      this.logsAction = null
    },
    showHideSubMenu (num) {
      if (!this.filerTableHead.selectedCeil) {
        this.filerTableHead.selectedCeil = num
      } else {
        this.filerTableHead.selectedCeil === num ? this.filerTableHead.selectedCeil = null : this.filerTableHead.selectedCeil = num
      }
    },
    hideSubMenuTableHead (e) {
      this.filerTableHead.selectedCeil = null
    },
    convertDate (payload) {
      if (!payload) return
      let date = new Date(payload)
      let fullYear = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let hours = date.getHours()
      let minutes = date.getMinutes()
      let ampm = hours >= 12 ? 'PM' : 'AM'
      let newHours = hours % 12 ? hours % 12 : 12
      function toDoubleDigit (num) {
        return num.toString().length < 2 ? '0' + num : num.toString()
      }
      let dateString = toDoubleDigit(day) + '.' + toDoubleDigit(month) + '.' + fullYear
      let timeString = toDoubleDigit(newHours) + ':' + toDoubleDigit(minutes) + ' ' + ampm
      return dateString + ' ' + timeString
    },
    changeOrderBy (order) {
      this.logOrderBy = {
        order: this.logOrderBy !== null ? !this.logOrderBy.order : order
      }
    },
    loadMore () {
      this.offset = this.offset + this.ppt
      this.fetchAllContentByScroll()
    },
    handleWindowResize (event) {
      this.windowWidth = event.currentTarget.innerWidth
    },
    getDeviceType (check) {
      let width = this.windowWidth
      let deviceName = ''
      if (width >= 940) {
        deviceName = 'desktop'
      } else if (width >= 480) {
        deviceName = 'tablet'
      } else {
        deviceName = 'mobile'
      }
      return check === deviceName
    },
    getTabletFiltersAppliedText () {
      let filterAppliedText = 'Apply Filters'
      if (this.selectedFilters.length) {
        filterAppliedText = 'Filters applied: ' + this.logs.length + ' results'
      }
      return filterAppliedText
    },
    getUser (log) {
      let user = this.logUsers.find((user) => user.id === log.userId)
      if (!user) {
        return 'n/a'
      }
      let fullName = ''
      if (user && user.firstName) {
        fullName += user.firstName + ' '
      }
      if (user && user.lastName) {
        fullName += user.lastName
      }
      if (user.status === 3) {
        return (fullName !== '' ? fullName : 'User') + ' [DELETED]'
      }
      return fullName !== '' ? fullName : 'n/a'
    },
    getEmail (log) {
      let user = this.logUsers.find((user) => user.id === log.userId)
      if (!user) {
        return 'n/a'
      }
      return user.email ? user.email : 'n/a'
    },
    getActionName (log) {
      return this.logActions[log.message]
    }
  },
  computed: {
    ...mapGetters([
      'getUserRole'
    ]),
    selectedFilters () {
      let filters = []
      if (this.logsUser) {
        filters.push(this.logsUser)
      }
      if (this.logsEmail) {
        filters.push(this.logsEmail)
      }
      if (this.logsCompany) {
        filters.push(this.logsCompany)
      }
      if (this.logsAction) {
        filters.push(this.logsAction)
      }
      return filters
    },
    getUsersForSelect () {
      return this.usersFilter
    },
    getEmailsForSelect () {
      return this.emailsFilter
    },
    getCompaniesForSelect () {
      return this.companiesFilter
    },
    getActionsForSelect () {
      return this.actionsFilter
    }
  },
  watch: {
    'logUsers' (value) {
      this.usersFilter = []
      this.emailsFilter = []
      value.forEach((user) => {
        let fullName = ''
        if (user.firstName) {
          fullName += user.firstName += ' '
        }
        if (user.lastName) {
          fullName += user.lastName
        }
        if (fullName !== '') {
          this.usersFilter.push({
            id: user.id,
            label: fullName
          })
        }
        if (user.status === '3') {
          this.emailsFilter.push({
            id: user.id,
            label: user.email + ' [DELETED]'
          })
        } else {
          this.emailsFilter.push({
            id: user.id,
            label: user.email
          })
        }
      })
    },
    'logCompanies' (value) {
      this.companiesFilter = []
      value.forEach((company) => {
        this.companiesFilter.push({
          id: company.id,
          label: company.name
        })
      })
    },
    'logActions' (value) {
      this.actionsFilter = []
      let keys = Object.keys(value)
      for (let i = 0; i < keys.length; i++) {
        let key = keys[i]
        this.actionsFilter.push({
          id: key,
          label: value[key]
        })
      }
    },
    'logOrderBy.order' (value) {
      this.order = value ? 'asc' : 'desc'
      this.offset = 0
      this.hideSubMenuTableHead()
      this.fetchAllContentByScroll(true)
    },
    'logsUser' (value) {
      if (value) {
        this.companyFilterLocked = true
        this.emailFilterLocked = true
      } else {
        this.companyFilterLocked = false
        this.emailFilterLocked = false
      }
      this.offset = 0
      this.hideSubMenuTableHead()
      this.fetchAllContentByScroll(true)
    },
    'logsEmail' (value) {
      if (value) {
        this.userFilterLocked = true
      } else {
        this.userFilterLocked = false
      }
      this.offset = 0
      this.hideSubMenuTableHead()
      this.fetchAllContentByScroll(true)
    },
    'logsCompany' () {
      this.offset = 0
      this.hideSubMenuTableHead()
      this.updateUsersFilter()
      this.fetchAllContentByScroll(true)
    },
    'logsAction' () {
      this.offset = 0
      this.hideSubMenuTableHead()
      this.getAllFilters()
      this.fetchAllContentByScroll(true)
    }
  },
  components: {
    AppSelect
  },
  created () {
    document.title = 'System logs | Clear Assured'
    if (window._paq) {
      window._paq.push(['setCustomUrl', location.pathname])
      window._paq.push(['setDocumentTitle', document.title])
      window._paq.push(['trackPageView'])
    }
    // if (window.ga) {
    //   window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
    //   window.ga('send', 'pageview', {
    //     'page': location.pathname,
    //     'location': location.href,
    //     'title': document.title
    //   })
    // }
  },
  mounted () {
    this.getAllFilters()
    this.fetchAllContentByScroll()
    document.addEventListener('click', this.hideSubMenuTableHead)
    window.addEventListener('resize', this.handleWindowResize)
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleWindowResize)
  },
  destroyed () {
    document.addEventListener('click', this.hideSubMenuTableHead)
  }
}
</script>

<style src='@/assets/scss/components/table.scss' lang='scss' ></style>



// WEBPACK FOOTER //
// Logs.vue?b2be5518